import { FAQ } from 'constants/textBunchesNames'
import withLocalization from 'containers/withLocalization'

import Component from './Faq'

const LocalizedComponent = withLocalization(Component, FAQ)

export default LocalizedComponent
